<template>
  <div
    :class="
      `anchor-container d-flex align-center justify-space-between ${
        !out ? 'flex-row-reverse' : ''
      }`
    "
    @mouseleave="showDeleteIcon = false"
    @mouseenter="showDeleteIcon = true"
    @contextmenu.stop="containerClicked($event)"
  >
    <span
      :class="
        `d-flex align-center justify-end ${!out ? 'flex-row-reverse' : ''}`
      "
      style="width: 100%; position: relative; left: 12px;"
      @mouseover="hoverAnchor = true"
      @mouseleave="hoverAnchor = false"
    >
      <span
        class="caption mt-1 text-capitalize"
        style="width: 65px"
        v-if="name === 'default'"
      >
        {{ name }}
      </span>
      <div
        v-else-if="name !== 'in'"
        class="caption d-flex w-100 flex-grow-1  justify-space-evenly mt-1"
        @dblclick="handleDoubleClickOnAnchor()"
        :style="
          `height: 24px; background-color: ${
            isNLP ? '#E1E1E1' : (isNLU ? '#FFC0CB' : '#CEBCFF')
          }; border-radius: 25px; border-bottom-right-radius: 0px; border-top-right-radius: 0px;`
        "
      >
        <span
          class="pa-1 flex-grow-1 align-self-stretch text-center text-truncate ml-1"
          style="width: 60px"
          >{{ variableAnchor }}</span
        >
        <span class="pa-1 text-center">|</span>
        <span
          class="pa-1 flex-grow-1 align-self-stretch text-center text-truncate"
          style="width: 60px"
          >{{ value }}</span
        >
      </div>
    </span>
    <v-btn
      v-if="name !== 'in'"
      :id="id"
      ref="anchor"
      text
      icon
      :color="color"
      @dblclick="tggleIsDoubleClicked"
      @mouseover="hoverAnchor = true"
      @mouseleave="hoverAnchor = false"
      :style="
        `position: absolute; right: ${
          name !== 'in' ? (isActive ? '-24px' : '-33px') : '0px'
        }; top: 6px; width: 20px; height: 20px; z-index: 9999`
      "
    >
      <v-icon v-if="isActive" size="22" class="mt-1" style="left: -1px;"
        >mdi-circle</v-icon
      >
    </v-btn>

    <v-btn
      v-else
      :id="id"
      ref="anchor"
      text
      icon
      :color="color"
      @mouseover="hoverAnchor = true"
      @mouseleave="hoverAnchor = false"
      :style="
        `position: absolute; right:'0px'; top: -8px; width: 20px; height: 20px;
            z-index: 9999`
      "
    >
      <v-icon v-if="isActive" size="22" class="mt-1" style="left: -1px;"
        >mdi-circle</v-icon
      >
    </v-btn>

    <div
      v-if="!isActive && out"
      class="anchor-right-flag mt-1"
      :style="`background-color: ${'' + colorFlag + ''}`"
    ></div>
    <div v-if="!isActive && !out" class="anchor-left-flag mt-1"></div>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title><span class="headline">Edit Anchor</span></v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- <v-col :cols="12">
                <v-text-field
                  placeholder="Name"
                  v-model="inputName"
                ></v-text-field>
              </v-col> -->
              <v-col :cols="6">
                <v-text-field
                  placeholder="Variable"
                  v-model="inputVariable"
                ></v-text-field>
              </v-col>
              <v-col :cols="6">
                <v-text-field
                  placeholder="Value"
                  v-model="inputValue"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <p
                v-if="showAnchorVariableError"
                style="font-size: medium; color: red; font-weight: 500; margin-left: 12px;"
              >
                The variable name should start with
                <span>"context.state"</span> or <span>"context.patient"</span> or <span>"context.metadata"</span>.
              </p>
            </v-row>
          </v-container></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            class="white-text"
            :disabled="inputVariable.length === 0 || inputValue.length === 0"
            @click="enableNameEditMode()"
          >
            Save
          </v-btn>
          <v-btn
            color="red"
            class="white-text"
            @click="closeDialog(variable, value)"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      v-model="dialogConnection"
      v-if="out"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      close-on-content-click
      :min-width="200"
      class="v-menu-canvas-link"
    >
      <v-list-item
        @click="anchorClicked($event)"
        style="background-color: white"
      >
        <v-list-item-icon>
          <v-icon v-text="iconTitle"></v-icon>
        </v-list-item-icon>
        <v-list-item-title>Connect anchor</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="name !== 'default' && name !== 'in'"
        @click="deleteAnchor"
        style="background-color: white"
      >
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Delete anchor</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="name !== 'default' && name !== 'in' && getIndex() != 1"
        @click="moveAnchor(-1)"
        style="background-color: white"
      >
        <v-list-item-icon>
          <v-icon>mdi-arrow-up-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Move up</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="
          name !== 'default' && name !== 'in' && getIndex() != getLength() - 1
        "
        @click="moveAnchor(1)"
        style="background-color: white"
      >
        <v-list-item-icon>
          <v-icon>mdi-arrow-down-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Move down</v-list-item-title>
      </v-list-item>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Anchor from "./Anchor";
import NewAnchor from "./NewAnchor";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
      required: true,
    },
    variable: {
      type: String,
      default: "",
      required: true,
    },
    value: {
      type: String,
      default: "",
      required: true,
    },
    color: {
      type: String,
      default: "primary",
    },
    languetteColor: {
      type: String,
      default: 'RED'
    },
    active: {
      type: Boolean,
      default: false,
    },
    out: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    isEnd: {
      type: Boolean,
    },
    available: {
      type: Boolean,
    },
    allAnchors: Object,
    currentNodeId: String,
    currentSkillId: String,
    openedMenuAnchor: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      dialog: false,
      dialogConnection: false,
      overlayDeleteIcon: false,
      showDeleteIcon: false,
      isEditMode: false,
      inputName: this.name,
      inputVariable: this.variable,
      inputValue: this.value,
      isActive: this.active || false,
      outConnections: 0,
      inConnections: 0,
      isClicked: false,
      isDoubleClicked: null,
      hoverAnchor: false,
      x: 0,
      y: 0,
      iconTitle: "mdi-link-variant",
      colorFlag: "red",
      showAnchorVariableError: false,
      anchorDefaultOptionsLeft: {
        connector: [
          "Bezier",
          {  curviness: 150 }
        ],
        //anchor:  "Left",
        anchor: [ 0.5, 0.5, -1, 0, -1, -1 ],
        endpoint: ["Rectangle", { width: 16, height: 16 }],
        paintStyle: { fillStyle: "yellow" },
        connectionStyle: { strokeStyle: "#666" },
        deleteEndpointsOnDetach: false,
        ReattachConnections: true,
        ConnectionsDetachable: true,
        allowLoopback: false,
        enabled: this.available,
      },
      anchorDefaultOptionsRight: {
        connector: [
          "Bezier",
          {  curviness: 150 }
        ],
        anchor: [ 0.5, 0.5, 1, 0, -3, -1 ],
        endpoint: ["Rectangle", { width: 16, height: 16 }],
        paintStyle: { fillStyle: "yellow" },
        connectionStyle: { strokeStyle: "#666" },
        deleteEndpointsOnDetach: false,
        ReattachConnections: true,
        ConnectionsDetachable: true,
        allowLoopback: false,
        enabled: this.available,
      },
    };
  },
  created() {
    this.$bus.$on('contextMenuClick', this.handleContextMenuClickEvent);
  },
  mounted() {
    const currentLinks = this.$store.state.links
    if (this.out) {
      this.canvas.makeSource(
        this.$refs.anchor.$el,
        Object.assign({}, this.anchorDefaultOptionsRight, {
          maxConnections: 2,
          isSource: true,
          enable: true,
          parameters: { _idSource: this.id, contextSource: this, id: this.id },
        })
      );

      this.outConnections = currentLinks.filter((x) => x.from === this.id).length;

      if (!this.available) {
        this.colorFlag = "gray";
        this.canvas.setSourceEnabled(this.$refs.anchor.$el, false);
      }
      if (this.isEnd) {
        this.colorFlag = "green";
        this.canvas.setSourceEnabled(this.$refs.anchor.$el, false);
      }
      if (this.languetteColor) this.colorFlag = this.languetteColor.toLowerCase()
    } else {
      this.canvas.makeTarget(
        this.$refs.anchor.$el,
        Object.assign({}, this.anchorDefaultOptionsLeft, {
          isTarget: true,
          enable: true,
          parameters: { _idTarget: this.id, contextTarget: this, id: this.id },
        })
      );

      this.outConnections = currentLinks.filter((x) => x.to === this.id).length;
    }
    // this.canvas.addEndpoint(this.$refs.anchor.$el, { uuid: this.id });
    this.isClicked = this.isEnd;
    this.isDoubleClicked = this.available;
  },
  methods: {
    ...mapActions({
      createAnchor: "http/anchors/createAnchor",
      updateAnchor: "http/anchors/updateAnchor",
      removeAnchor: "http/anchors/removeAnchor",
      updateNode: "http/nodes/updateNode",
      getLinks: "http/links/getLinks",
      getNode: "http/nodes/getNode",
    }),
    deleteAnchor() {
      this.$emit("onDeleted", this.id);
    },
    enableNameEditMode() {
      if (
        this.inputVariable.length > 0 &&
        (this.inputVariable.startsWith("context.state") ||
          this.inputVariable.startsWith("context.patient") ||
            this.inputVariable.startsWith("context.metadata")) &&
        this.inputValue.length > 0
      ) {
        this.$emit("onChanged", {
          id: this.id,
          name: this.inputName,
          variable: this.inputVariable,
          value: this.inputValue,
        });
        this.showAnchorVariableError = false;
        this.dialog = false;
      } else {
        this.showAnchorVariableError = true;
      }
    },
    // Getting index of current anchor inside a node
    getIndex() {
      var listAnchorsOut = this.allAnchors.out;
      var listId = [];
      for (var i = 0; i < listAnchorsOut.length; i++) {
        var tmpId = listAnchorsOut[i]._id;
        !listId.push(tmpId);
      }
      const index = listId.indexOf(this.id);
      return index;
    },
    // Getting length of anchors.out list
    getLength() {
      return this.allAnchors.out.length;
    },
    // Move the present anchor Up  (1) || down (-1)
    async moveAnchor(to) {
      // Moving the anchors list in the page
      var listAnchorsOut = this.allAnchors.out;
      const index = this.getIndex();
      const currentAnhor = listAnchorsOut[index];
      const targetAnchor = listAnchorsOut[index + to];
      // this.canvas.deleteEveryConnection();
      // await this.getLinks().then(links => {
      //   console.log("all links :", links)
      //   setTimeout(() => {
      //     links.forEach((link) => {
      //       this.canvas.connect({
      //         source: document.getElementById(link.from),
      //         target: document.getElementById(link.to),
      //         hoverPaintStyle: { strokeWidth: "10px" },
      //       });
      //     });
      //   }, 500);
      // })
      listAnchorsOut[index + to] = currentAnhor;
      listAnchorsOut[index] = targetAnchor;
      // Moving the anchors list in the database
      const myNode = await this.getNode({
        skillId: this.currentSkillId,
        idNode: this.currentNodeId,
      });
      const nodeAnchors = myNode.anchors;
      if (nodeAnchors.length == listAnchorsOut.length + 1) {
        const currentNodeAnchor = nodeAnchors[index + 1];
        const targetNodeAnchor = nodeAnchors[index + to + 1];
        nodeAnchors[index + to + 1] = currentNodeAnchor;
        nodeAnchors[index + 1] = targetNodeAnchor;
      } else {
        const currentNodeAnchor = nodeAnchors[index];
        const targetNodeAnchor = nodeAnchors[index + to];
        nodeAnchors[index + to] = currentNodeAnchor;
        nodeAnchors[index] = targetNodeAnchor;
      }
      // Updating database
      await this.updateNode({
        skillId: this.currentSkillId,
        idNode: this.currentNodeId,
        data: { anchors: nodeAnchors },
      });

      this.allAnchors.out = listAnchorsOut;
      this.$emit("onUpdateAnchors", this.allAnchors);
    },
    toggleIsClicked() {
      this.isClicked = !this.isClicked;
      this.$emit("onMarkEndNode", this.isClicked);
    },
    tggleIsDoubleClicked() {
      if (this.colorFlag === "red") {
        this.colorFlag = "green";
        this.canvas.setSourceEnabled(this.$refs.anchor.$el, false);
      } else if (this.colorFlag === "green") {
        this.isDoubleClicked = !this.isDoubleClicked;
        this.colorFlag = "blue";
        this.canvas.setSourceEnabled(this.$refs.anchor.$el, true);
      } else if (this.colorFlag === "blue") {
        this.colorFlag = "gray";
        this.canvas.setSourceEnabled(this.$refs.anchor.$el, false);
      } else {
        this.colorFlag = "red";
        this.canvas.setSourceEnabled(this.$refs.anchor.$el, true);
      }
      this.$emit("onMarkEndNode", this.colorFlag === 'green');
      this.$emit("onChanged", {
        id: this.id,
        name: this.inputName,
        variable: this.inputVariable,
        value: this.inputValue,
        available: this.colorFlag !== "blue",
        color: this.colorFlag.toUpperCase()
      });
    },

    containerClicked(e) {
      e.preventDefault();
      this.x = e.pageX;
      this.y = e.pageY;
      this.$emit("menuOpened", this.id);
      this.$bus.$emit('contextMenuClick', this.id);
      this.$store.commit('setShowMenuLink', false)
      this.dialogConnection = true;
    },
    anchorClicked(e) {
      if (this.out) {
        this.$emit("onConnectionAnchor", {
          id: this.id,
          anchorOutState: this.out,
        });
      }
    },
    async closeDialog(variable, value) {
      this.dialog = false;
      this.inputValue = value;
      this.inputVariable = variable;
    },
    handleDoubleClickOnAnchor() {
      this.dialog = true;
    },
    handleContextMenuClickEvent(eventSource) {
      if(eventSource !== "anchor") {
        this.dialogConnection = false;
        this.dialog = false;
      }
    }
  },
  computed: {
    canvas: {
      get() {
        return this.$store.state.canvas.canvas;
      },
    },
    isNLP: {
      get() {
        return this.variable.includes("nlp");
      },
    },
    isNLU: {
      get() {
        return this.variable.includes("nlu");
      },
    },
    variableAnchor: {
      get() {
        if (this.variable.includes("nlp") || this.variable.includes("nlu"))
          return this.variable
            .split(".")
            .slice(3)
            .join(".");
        return this.variable
          .split(".")
          .slice(2)
          .join(".");
      },
    },
  },
  watch: {
    hoverAnchor(value) {
      const connection = this.canvas.getConnections();
      if (value) {
        for (const conn of connection) {
          if (conn.sourceId === this.id) {
            conn.setType("selected");
            this.$emit("onHoverAnchor", { connection: conn, active: true });
          }
        }
      } else {
        for (const conn of connection) {
          if (conn.sourceId === this.id) {
            conn.setType("basic");
            this.$emit("onHoverAnchor", { connection: conn, active: false });
          }
        }
      }
    },
    openedMenuAnchor(newVal) {
      if (this.id !== newVal) {
        this.$nextTick(() => {
          this.dialogConnection = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.anchor-container {
  width: 100%;
  position: relative;
}

.anchor-type {
  position: absolute;
  transform: center center;
  z-index: -1;
  padding: 2px 15px;
  cursor: pointer;
}

.anchor-type.out {
  left: 105%;
}
.anchor-type.in {
  right: 105% !important;
}

.anchor-name-input input {
  text-align: left;
}

.anchor-right-flag {
  border-radius: 0% 50% 50% 0%;
  background-color: #ff0000;
  width: 24px;
  height: 24px;
  right: -36px;
  position: absolute;
}

.anchor-left-flag {
  border-radius: 50% 0% 0% 50%;
  background-color: #ff0000;
  width: 24px;
  height: 24px;
  left: -36px;
  position: absolute;
}
.white-text {
  color: white !important;
  font-weight: bold;
}
</style>
